import { CardElement } from "@stripe/react-stripe-js";
import type { StripeElementStyle } from "@stripe/stripe-js";
import { memo, useMemo } from "react";
import { StyleSheet } from "react-native";

import { Block, palette, spacing } from "@stepapp/ui";

// For web use only
export const CardForm = memo(function CardForm() {
  const options = useMemo(() => {
    const baseStyle = {
      lineHeight: "22px",
      fontSize: "16px",
      "font-family": "SharpGroteskBook20",
    } as StripeElementStyle["base"];

    return {
      iconStyle: "solid",
      hidePostalCode: true,
      style: {
        base: baseStyle,
        complete: baseStyle,
        empty: baseStyle,
        invalid: baseStyle,
      },
    } as const;
  }, []);

  return (
    <Block borderRadius={1} padding={2} style={styles.cardContainer}>
      <CardElement options={options} />
    </Block>
  );
});

const styles = StyleSheet.create({
  cardContainer: {
    borderColor: palette.common.mediumGray,
    borderWidth: spacing.border,
    boxShadow: "0px 1px 3px rgba(230, 235, 241, 0.25)",
  },
});
